import firebase from "../firebase";
import displayListingGenerateHtml from "../display-listing/generate-html";
import displayPromotedItemsGenerateHtml from "../promoted-items/generate-html.js";

import displayListingEach from "../dispay-listings-each/display";

import DisplayBusinessEach from "../display-business-each/display";
import GENRALHELPERS from "../GENRAL-HELPERS";
import ownListings from "../own-listing-actions/own-listings";
import help from "../help/help";
import spinner from "../spinner";
import nav from "../home-screen/nav";
import displayIndSellers from "../ind-seller/display-ind-sellers";
import businessEach from "../display-business-each/display.js";

import ctaAlert from "../CTA-Alert/cta-alert";
import promotedItems from "../promoted-items/promoted-items";
import homeScreen from "../home-screen/home-screen.js";

import StackDisplay from "../../modules/stack-display/display";
import { set } from "firebase/database";

// import openUrls from "../open-app-urls/open-urls";

// display._init(data);
const omittedWords = ["the"];

let data = { listings: [], businesses: {} };
const colors = {
  headerPrimary: "FFFFFF",
  headerSecondary: "E0E0E0",
  packTitles: "6D6D6D",
  packTitlesHighlight: "3A7D44",
  itemBackgroundPrimary: "3A7D44",
  itemBackgroundSecondary: "fff",
  itemTextPrimary: "FFFFFF",
  itemTextSecondary: "2B2B2B",
  itemTextTerteriary: "3A7D44",
  itemTextFour: "3A7D44",
  itemHighlight: "FF7043",
  itemHighlightText: "FFFFFF",
};

class AllDisplaysInitial {
  #isMoreLoadingInitializedForBusinesses;


  #trackedRequestNumber = 0;

  #startSearchIsActive = false;
  #userIsInSearch = false;

  #CTAShareEventsInitialized = false






  // START REWRITE
  // listings

  #listingsDevided = 'all'

  #inCurrentCategory = "listings";
  #displayFromMostRecentListings = false;
  #isLoadingListings = false
  #listingsMostRecentLastVisDoc = null
  #isListingSearch = false;
  #isCalledFrom = 'home'

  #isListingLocationFilter = false;
  #allListingsLoaded = false;
  #nextLoopIndex = 0;

  #currentSearchListingCount = 0
  #currentSearchListingLimit = 10
  #listingsSearchResultpathsArr = []

  #userMachineInterestArr = [];
  #userMachineInterestSortedShowArr = [];
  #detectBottomScrollListingnsOn = false;
  #isExitSearch = false;

  #currentSearchQuery = ''

  #locationFilterData = {}
  #locationFilterLastVisibleDoc = null

  // Busiensses
  #businessLastVisDoc = null;
  #allBusinessesLoaded = false;
  #isLoadingBusinesses = false
  #isBusinessesSearch = false

  #currentSearchBusinessesCount = 0
  #currentSearchBusinessesLimit = 6
  #businessesSearchResultpathsArr = []

  // Sellers
  #sellersLastVisDoc = null;
  #allSellersLoaded = false;
  #isLoadingSellers = false;
  #isSellersSearch = false;

  #currentSearchSellersCount = 0
  #currentSearchSellersLimit = 8
  #sellersSearchResultpathsArr = []

  #allListingsLoadedInLocationFilter = false


  // Promoted items
  #allPromotedLoaded = false;

  #blockAutoPaddingTop = false
  #miniHeight = 0;

  #scrollStates = new Map();

  #dinaMaxHeight = false



  #isProgrammaticScroll = false;
  #lastStage = 'FULL';
  #stageResetTimer = null;
  #currentScrollId = null;
  #lockHeaderStage = false;
  #lockHeaderStageDrag = false;



  // START Promoted items

  #lastVisDocMercadoLibre = null
  #lastVisDocAmazon = null
  #lastVisDocEbay = null
  #isLoadingPromotedItems = false
  #allPromotedMercadoLibreItemsLoaded = false
  #allPromotedAmazonItemsLoaded = false
  #allPromotedEbayItemsLoaded = false



  #listingInEditElement = null
  #listingInEditType = null
  #listingInEditDotsButton = null
  #listingInEditId = null

  constructor() {
    this.abortController = new AbortController(); // Initialize AbortController
    const myArr = [
      { machine: "rastra", time: Date.now() },
      { machine: "retroexcavadora", time: Date.now() },
    ];
    // GENRALHELPERS._saveArrayLocalStorage(
    //   "UserMachineInterestTrackerArr",
    //   myArr
    // );
    this._getUserMachineInterest();

    // this._CTAShareLiting()

    // MercadoLibre link preview is experimental and the 'previewContainer' has to be in set to display flex in the HTML
    // this._handleLinkPreview("previewContentContainer", "previewLinkInput");


  }

  _getIsInSearchState() {
    let inSearch = false
    if (this.#isListingSearch || this.#isBusinessesSearch || this.#isSellersSearch) {
      inSearch = true
    }
    return inSearch
  }

  _getCurrentCategory() {
    return this.#inCurrentCategory
  }
  _getUserMachineInterest() {
    const retrievedMachineInterest = GENRALHELPERS._getArrayLocalStorage(
      "UserMachineInterestTrackerArr"
    );
    console.log(retrievedMachineInterest);

    this.#userMachineInterestArr = [];
    retrievedMachineInterest.forEach((machine) => {
      this.#userMachineInterestArr.push({
        ...machine,
        numberGet: 4,
        lastDocVisible: null,
        skip: false,
      });
    });
  }
  async _preparaAllMachineTypes() {
    this.#userMachineInterestSortedShowArr = [];
    const data = await firebase._getMachineData("machineTypes");

    // console.log(data);
    const mergeUserMachineInterest = (data) => {
      // console.log(data);
      const currentMachines = this.#userMachineInterestArr.map(
        (obj) => obj.machine
      );

      const newMachines = data
        .filter((item) => !currentMachines.includes(item.data.name))
        .map((item) => ({
          machine: item.data.name,
          lastDocVisible: null,
          numberGet: 4,
          skip: false,
        }));

      this.#userMachineInterestArr =
        this.#userMachineInterestArr.concat(newMachines);
    };
    mergeUserMachineInterest(data);

    // console.log(this.#userMachineInterestArr);
    const logMachinesSortedAndShuffled = async (arr) => {
      const withTime = [];
      const withoutTime = [];

      // Separate the entries
      arr.forEach((obj) => {
        if ("time" in obj) {
          withTime.push(obj);
        } else {
          withoutTime.push(obj);
        }
      });

      // Helper: Shuffle array in place (Fisher-Yates)
      function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
      }

      // Group by time and shuffle ties
      const timeGroups = {};

      withTime.forEach((obj) => {
        if (!timeGroups[obj.time]) timeGroups[obj.time] = [];
        timeGroups[obj.time].push(obj);
      });

      let sortedWithTime = Object.entries(timeGroups)
        .sort((a, b) => b[0] - a[0]) // sort time DESC
        .flatMap(([_, group]) => shuffle(group)); // shuffle same time group

      const shuffledWithoutTime = shuffle(withoutTime);

      // Final ordered list
      const finalList = [...sortedWithTime, ...shuffledWithoutTime];

      // Log machine names
      finalList.forEach((obj) =>
        this.#userMachineInterestSortedShowArr.push(obj)
      );
    };
    logMachinesSortedAndShuffled(this.#userMachineInterestArr);
  }

  _scrollContainerToTop(conId) {

    const el = document.getElementById(conId);
    if (!el) return;

    el.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  }

  _scrollToTopOfCurrentCategory() {

    console.log(this.#inCurrentCategory);
    if (this.#inCurrentCategory === 'promotedItems') {
      this._scrollContainerToTop("NVHomeMainContainerPromotedItems");
    }
    if (this.#inCurrentCategory === 'listings') {
      this._scrollContainerToTop("NVHomeMainContainerListings");
    }
    if (this.#inCurrentCategory === 'businesses') {
      this._scrollContainerToTop("NVHomeMainContainerBusinesses");
    }
    if (this.#inCurrentCategory === 'indsellers') {
      this._scrollContainerToTop("NVHomeMainContainerSellers");
    }

  }

  _changeMainCategory(category) {
    const NVHomeMainContainerListings = document.getElementById("NVHomeMainContainerListings");
    const NVHomeMainContainerBusinesses = document.getElementById("NVHomeMainContainerBusinesses");
    const NVHomeMainContainerSellers = document.getElementById("NVHomeMainContainerSellers");

    const locationFilterParentCon = document.getElementById("locationFilterParentCon");
    const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
    const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");
    const buttonScrollTop = document.getElementById("homeScreenDisplayInitialScreenScrollButtonScrollTop");
    buttonScrollTop.style.display = "none";


    console.log(category);
    if (category === "listings") {

      locationFilterParentCon.style.display = "none";

      if (!this.#isListingSearch) {
        locationFilterParentCon.style.display = "flex";
      }

      NVHomeMainContainerBusinesses.style.display = "none";
      NVHomeMainContainerSellers.style.display = "none";

      this._headerStageReseter('HALF')
      this._addHeader3Stage('NVHomeMainContainerListings')

      this._alignItemsConToHeaderBottom('NVHomeMainContainerListings')

      console.log('here')
      NVHomeMainContainerListings.style.display = "flex";
      this.#listingsDevided = 'all';
      this._loadListings(true)
    }
    if (category === "businesses") {
      this._changeBetweenPromotedItems()

      NVHomeMainContainerListings.style.display = "none";
      NVHomeMainContainerSellers.style.display = "none";

      locationFilterParentCon.style.display = "none";


      this._headerStageReseter('HALF')
      this._addHeader3Stage('NVHomeMainContainerBusinesses')
      this._alignItemsConToHeaderBottom('NVHomeMainContainerBusinesses')
      NVHomeMainContainerBusinesses.style.display = "flex";
      this._initBusinessLoads();
    }
    if (category === "indsellers") {
      this._changeBetweenPromotedItems()

      NVHomeMainContainerListings.style.display = "none";
      NVHomeMainContainerBusinesses.style.display = "none";

      locationFilterParentCon.style.display = "none";

      this._headerStageReseter('HALF')
      this._addHeader3Stage('NVHomeMainContainerSellers')

      this._alignItemsConToHeaderBottom('NVHomeMainContainerSellers')
      NVHomeMainContainerSellers.style.display = "flex";
      this._initSellersLoads()
    }
    if (category === "promotedItems") {
      this._changeBetweenPromotedItems(true)

      console.log('Promoted items now')

      NVHomeMainContainerListings.style.display = "none";
      NVHomeMainContainerBusinesses.style.display = "none";
      NVHomeMainContainerSellers.style.display = "none";

      this._headerStageReseter('HALF')
      this._addHeader3Stage('NVHomeMainContainerPromotedItems')

      this._alignItemsConToHeaderBottom('NVHomeMainContainerPromotedItems')
      this._initPromotedItmesLoad(true)
    }
    this.#inCurrentCategory = category;

  }

  _changeBetweenPromotedItems(promoted = false) {
    return
    // const homeHeaderSearchSearchCon = document.getElementById('homeHeaderSearchSearchCon')
    // const homeHeaderSearchCon10 = document.getElementById('homeHeaderSearchCon10')
    // const NVHeaderConSearchCon2B = document.getElementById("NVHeaderConSearchCon2B");


    const NVHeaderConSearchCon2B1PromotedText1Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText1Parent");
    const NVHeaderConSearchCon2B1PromotedCuponParent = document.getElementById("NVHeaderConSearchCon2B1PromotedCuponParent");
    const NVHeaderConSearchCon2B1PromotedText2Parent = document.getElementById("NVHeaderConSearchCon2B1PromotedText2Parent");

    const NVHeaderConSearchCon2B1PromotedText1 = document.getElementById("NVHeaderConSearchCon2B1PromotedText1");
    const NVHeaderConSearchCon2B1PromotedCupon = document.getElementById("NVHeaderConSearchCon2B1PromotedCupon");
    const NVHeaderConSearchCon2B1PromotedText2 = document.getElementById("NVHeaderConSearchCon2B1PromotedText2");


    // homeHeaderSearchSearchCon.classList.remove('NVHeaderConSearchCon2PromotedItems')
    // homeHeaderSearchCon10.style.display = 'flex'
    // NVHeaderConSearchCon2B.style.display = 'flex'
    NVHeaderConSearchCon2B1PromotedText1Parent.style.display = 'none'
    NVHeaderConSearchCon2B1PromotedCuponParent.style.display = 'none'
    NVHeaderConSearchCon2B1PromotedText2Parent.style.display = 'none'

    if (promoted) {
      // homeHeaderSearchSearchCon.classList.add('NVHeaderConSearchCon2PromotedItems')
      // homeHeaderSearchCon10.style.display = 'none'
      // NVHeaderConSearchCon2B.style.display = 'none'

      // NVHeaderConSearchCon2B1PromotedText1Parent.style.display = 'flex'
      // NVHeaderConSearchCon2B1PromotedCuponParent.style.display = 'flex'
      // NVHeaderConSearchCon2B1PromotedText2Parent.style.display = 'flex'



      // NVHeaderConSearchCon2B1PromotedText1.textContent = 'Encuentra los articulos que ocupas.'
      // NVHeaderConSearchCon2B1PromotedCupon.textContent = 'FRIDAY100'
      // NVHeaderConSearchCon2B1PromotedText2.textContent = 'Usa el código de ariba para tener $100 de descuento en compras mayores a $1000'


    }

  }

  _activateDetectScrollToBottomListings = (margin = 0, recent = false) => {
    if (this.#detectBottomScrollListingnsOn) return;
    this.#detectBottomScrollListingnsOn = true;

    const reuseFunction = (id) => {
      const container = document.getElementById(id);
      if (!container) {
        console.log("Error: Container not found.");
        return;
      }
      this._detectScrollDirection(container);

      // Add a scroll event listener
      container.addEventListener("scroll", async () => {
        console.log("Scroll event detected in container:", id);
        const isScrolledToBottom =
          container.scrollHeight -
          container.scrollTop -
          container.clientHeight <=
          margin;

        if (isScrolledToBottom) {
          console.log('here');
          if (this.#inCurrentCategory === "listings") {
            console.log("Scroll event detected in container, listings:", id);
            this._loadListings(false, true);
          }

          if (this.#inCurrentCategory === "businesses") {
            console.log("Scroll event detected in container, businesses:", id);
            if (!this.#allBusinessesLoaded) {
              this._loadBusinesses();
            }
          }

          if (this.#inCurrentCategory === "indsellers") {
            console.log("Scroll event detected in container, indsellers:", id);
            if (!this.#allSellersLoaded) {
              this._loadSellers();
            }
          }


          if (this.#inCurrentCategory === "promotedItems") {
            if (!this.#allPromotedLoaded) {
              this._initPromotedItmesLoad();
            }
          }
        }
      });
    }
    reuseFunction('NVHomeMainContainerListings')
    reuseFunction('NVHomeMainContainerBusinesses')
    reuseFunction('NVHomeMainContainerSellers')
  }
  _emptyContainer(id) {
    const MainHomeContainerForAllItemsDisplay = document.getElementById(
      id
    );
    MainHomeContainerForAllItemsDisplay.innerHTML = "";
  }
  _addTheRightPaddingToItemsCon(id, extraPadding = 20) {
    const header = document.getElementById("homeHeaderSearchCon1");
    const target = document.getElementById(id);

    if (!header || !target) return;

    const updatePadding = () => {

      if (this.#dinaMaxHeight) return
      if (this.#blockAutoPaddingTop) return
      const headerHeight = header.offsetHeight;
      target.style.paddingTop = `${headerHeight + extraPadding}px`;
    };

    // Initial set
    updatePadding();

    // Observe real height changes
    const resizeObserver = new ResizeObserver(() => {
      updatePadding();
    });

    resizeObserver.observe(header);
  }





  // START Listings Handeling
  async _initListingLoads(reset) {

    console.log("Initializing listing loads, reset =", reset);

    if (reset) {
      await this._preparaAllMachineTypes();
      this._emptyContainer('NVHomeMainContainerListings')
      this.#userMachineInterestSortedShowArr.forEach((m) => {
        m.lastDocVisible = null;
        m.skip = false;
      });


      this.#nextLoopIndex = 0;
      this.#allListingsLoaded = false;
      this.#allListingsLoadedInLocationFilter = false
      this.#isListingSearch = false; // Maybe this line should be removed, if any abnormalies are noted.
      this.#isListingLocationFilter = false;

      this.#currentSearchListingCount = 0
      this.#currentSearchListingLimit = 10
      this.#listingsSearchResultpathsArr = []

      setTimeout(() => {
        this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
      }, 10);
    }
    this._searchPlaceHolderChangeTo("Buscar Listados");


    this._loadListings(reset);

  }



  async _loadListings(reset, isfromScroll = false) {
    this._searchPlaceHolderChangeTo("Buscar Listados");

    console.log(this.#listingsDevided);
    try {
      setTimeout(() => {
        this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
      }, 10);
      if (reset) {
        console.log('yep here');
        this.#allListingsLoaded = false
        if (this.#listingsDevided === 'all') {
          await this._preparaAllMachineTypes();
          this.#userMachineInterestSortedShowArr.forEach((m) => {
            m.lastDocVisible = null;
            m.skip = false;
          });
        }
        this._emptyContainer('NVHomeMainContainerListings')
      }

      console.log(this.#isLoadingListings, this.#allListingsLoaded);

      if (this.#isLoadingListings) return;
      if (this.#allListingsLoaded) return;

      if (this.#listingsDevided === 'all') {
        this.#isLoadingListings = true;
        await this._allListingsGetLoop(this.#userMachineInterestSortedShowArr, 12);
        this.#isLoadingListings = false;
      }

      if (this.#listingsDevided === 'search') {
        this.#isLoadingListings = true;
        await this._searchListingsGetLoop();
        this.#isLoadingListings = false;
      }
      if (this.#listingsDevided === 'locationFilter') {
        this.#isLoadingListings = true;
        await this._locationFilterListingsGetLoop(isfromScroll);
        this.#isLoadingListings = false;
      }

    } catch (err) {
      console.error("Error in _loadListings:", err);
    } finally {
      console.log('Finished loading listings');
      // this._activateDetectScrollToBottomListings(100);
      setTimeout(() => {
        this._addTheRightPaddingToItemsCon('NVHomeMainContainerListings', 20);
      }, 10);
    }
  }

  async _allListingsGetLoop(
    arr = this.#userMachineInterestSortedShowArr,
    maxListings = 12,
  ) {
    try {

      console.log('HERE Now')
      if (this.#nextLoopIndex === undefined) this.#nextLoopIndex = 0;

      const arrLength = arr.length
      let index = this.#nextLoopIndex;
      let iterations = 0;
      let loadedCount = 0;

      while (iterations < arrLength && loadedCount < maxListings) {
        const machineObj = arr[index];
        const { machine, numberGet, skip } = machineObj;

        if (!skip) {
          try {
            const { listings, lastVisibleDoc } =
              await firebase._getMostRelevantListingsWithFilter(
                machineObj.lastDocVisible,
                numberGet,
                "listingMachineType",
                machine
              );

            if (listings && listings.length > 0) {
              machineObj.lastDocVisible = lastVisibleDoc;
              loadedCount += listings.length;

              if (listings.length < numberGet) {
                machineObj.skip = true;
              }
              this.#isCalledFrom = 'home'
              this._fillListings(listings.slice(0, maxListings - loadedCount), 'all');
            } else {
              machineObj.skip = true;
            }
          } catch (err) {
            console.error(`Error for ${machine}:`, err);
            machineObj.skip = true;
          }
        }

        index = (index + 1) % arrLength;
        iterations++;
      }

      this.#nextLoopIndex = index;

    } finally {

      if (this.#isListingSearch) return
      const ListingsContianer = document.getElementById(
        "NVHomeMainContainerListings"
      );
      const addSet = homeScreen._makeAddSetToInsert();
      ListingsContianer.insertAdjacentHTML(
        "beforeend",
        addSet
      );

      spinner._hideSpinner();

    }
  }
  async _searchListingsGetLoop() {
    try {

      if (this.#currentSearchQuery?.length < 1) return
      if (this.#allListingsLoaded) return

      console.warn("Searching for:", this.#currentSearchQuery);
      let resultpathsArr = this.#listingsSearchResultpathsArr
      if (this.#listingsSearchResultpathsArr.length < 1) {
        spinner._displaySpinner()
        this.#listingsSearchResultpathsArr = await firebase._NVsearchListings({ query: this.#currentSearchQuery })
        resultpathsArr = this.#listingsSearchResultpathsArr
        spinner._hideSpinner()
      }
      console.warn(resultpathsArr);

      if (!resultpathsArr || resultpathsArr?.data?.listings?.length < 1) {
        if (this.#currentSearchListingCount < 1) {
          alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`)
        }
        return
      } else {

        while (
          this.#currentSearchListingCount <= this.#currentSearchListingLimit &&
          this.#currentSearchListingCount < resultpathsArr?.data?.listings?.length
        ) {
          const index = this.#currentSearchListingCount;
          const listingsArr = resultpathsArr.data.listings;

          // If this is the LAST available listing
          if (index === listingsArr.length - 1) {
            this.#allListingsLoaded = true;
          }

          const resultpathArr = listingsArr[index];
          if (!this.#isListingSearch) return
          const listing = await firebase._getAnyDocById(resultpathArr);

          if (!this.#isListingSearch) return
          this.#isCalledFrom = 'search'
          this._fillListings([listing], 'search');

          this.#currentSearchListingCount++;
        }

        // ✅ Increase limit AFTER loading this batch
        this.#currentSearchListingLimit += 10;
      }


    } finally {

      spinner._hideSpinner();

    }
  }
  async _locationFilterListingsGetLoop(
    isfromScroll = false
  ) {

    console.error('yeo, used', this.#listingsDevided);
    try {
      if (this.#isListingLocationFilter) {
        console.log('HERE Now')

        if (this.#allListingsLoadedInLocationFilter) return
        console.log('still going');
        spinner._displaySpinner()


        const filterData = {
          lat: this.#locationFilterData.lat,
          lng: this.#locationFilterData.lng,
          radiusKm: this.#locationFilterData.radius,
          lastVisibleMap: this.#locationFilterLastVisibleDoc,
        }


        if (!filterData.lat || !filterData.lng || !filterData.radiusKm) {
          console.error('Missing location filter data:', filterData);
          spinner._hideSpinner()
          return
        }
        const { listings, lastVisibleMap, isAllListingsLoaded } = await firebase._getListingsNearby(filterData)

        setTimeout(() => {
          if (listings?.length < 3 && !isfromScroll) {
            this.#lockHeaderStageDrag = true
            this._headerStageReseter('FULL')
          } else {
            this.#lockHeaderStageDrag = false
          }
        }, 500);

        this.#allListingsLoadedInLocationFilter = isAllListingsLoaded
        this.#locationFilterLastVisibleDoc = lastVisibleMap
        spinner._hideSpinner()
        this._fillListings(listings, 'locationFilter');
      }
    } finally {
      spinner._hideSpinner();
    }
  }


  async _fillListings(listings, isCalledFrom = 'all') {
    const ListingsContianer = document.getElementById(
      "NVHomeMainContainerListings"
    );
    for (const listing of listings) {
      if (isCalledFrom !== this.#listingsDevided) return
      if (this.#inCurrentCategory === "listings") {
        let html = displayListingGenerateHtml._listingVerticalNV(listing, true);
        if (isCalledFrom !== this.#listingsDevided) return
        ListingsContianer.insertAdjacentHTML(
          "beforeend",
          html
        );
      }
    }

    // const addSet = homeScreen._makeAddSetToInsert();
    // ListingsContianer.insertAdjacentHTML(
    //   "beforeend",
    //   addSet
    // );
  }
  // END Listings Handeling



  // START Businesses Handeling
  async _initBusinessLoads(reset) {
    console.log("Initializing businesses loads, reset =", reset);

    if (reset) {
      this._emptyContainer('NVHomeMainContainerBusinesses')

      this.#businessLastVisDoc = null;
      this.#allBusinessesLoaded = false;
      this.#isLoadingBusinesses = false;


      this.#businessesSearchResultpathsArr = []
      this.#currentSearchBusinessesCount = 0
      this.#currentSearchBusinessesLimit = 6
    }
    setTimeout(() => {
      this._addTheRightPaddingToItemsCon('NVHomeMainContainerBusinesses', 20);
    }, 10);

    this._searchPlaceHolderChangeTo("Buscar Empresas");

    this._loadBusinesses();

  }
  async _loadBusinesses() {
    if (this.#isLoadingBusinesses) return;
    this.#isLoadingBusinesses = true;

    await this._startGetLoopForBusinesses();
    this.#isLoadingBusinesses = false;
  }
  async _startGetLoopForBusinesses(numberGet = 5) {

    console.error('Called load')
    if (this.#allBusinessesLoaded) return
    console.warn("called");

    if (!this.#isBusinessesSearch) {
      console.warn("called here");
      const { listings, lastVisibleDoc } =
        await firebase._getRecentListingsWithFilter(
          this.#businessLastVisDoc,
          numberGet,
          "businesses",
          "status",
          "active"
        );
      console.log(listings, lastVisibleDoc);
      this._fillBusinesses(listings);
      if (listings.length < numberGet) {
        this.#allBusinessesLoaded = true;
      }
      this.#businessLastVisDoc = lastVisibleDoc;

    } else {
      console.error('Called load')
      if (this.#currentSearchQuery?.length < 1) return

      console.warn("Searching for:", this.#currentSearchQuery);
      let resultpathsArr = this.#businessesSearchResultpathsArr
      if (this.#businessesSearchResultpathsArr.length < 1) {
        spinner._displaySpinner()
        this.#businessesSearchResultpathsArr = await firebase._NVsearchBusinesses({ query: this.#currentSearchQuery })
        resultpathsArr = this.#businessesSearchResultpathsArr
        spinner._hideSpinner()
      }
      console.warn(resultpathsArr);

      if (!resultpathsArr || resultpathsArr?.data?.businesses?.length < 1) {
        if (this.#currentSearchListingCount < 1) {
          alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`)
        }
        return
      } else {
        while (
          this.#currentSearchBusinessesCount <= this.#currentSearchBusinessesLimit &&
          this.#currentSearchBusinessesCount < resultpathsArr?.data?.businesses?.length
        ) {
          const index = this.#currentSearchBusinessesCount;
          const businessesArr = resultpathsArr.data.businesses;

          // If this is the LAST available listing
          if (index === businessesArr.length - 1) {
            this.#allListingsLoaded = true;
          }

          const resultpathArr = businessesArr[index];
          if (!this.#isBusinessesSearch) return
          const business = await firebase._getAnyDocById(`businesses/${resultpathArr}`);
          if (!this.#isBusinessesSearch) return
          this._fillBusinesses([business], true);

          this.#currentSearchBusinessesCount++;
        }

        // ✅ Increase limit AFTER loading this batch
        this.#currentSearchBusinessesLimit += 6;
      }
    }
  }
  async _fillBusinesses(businessesIn, isCalledFromSearch = false) {
    if (businessesIn.length < 1) {
      spinner._hideSpinner();
    }
    const dataLocal = { businesses: {} }; // Initialize data object

    try {
      let businesses = businessesIn;

      // Process businesses
      const processedBusinesses = await Promise.all(
        businesses.map(async (business) => {
          // Fetch listings for the business
          const { listings, lastVisibleDoc } =
            await firebase._getRecentListingsWithFilter(
              null,
              6,
              `businesses/${business.businessId}/listings`
            );

          // Overwrite business in the data object
          dataLocal.businesses[business.businessId] = {
            ...business,
            listings: listings || [],
          };

          return { ...business, listings };
        })
      );

      // Generate and display HTML for businesses and their listings
      const businessCon = document.getElementById(
        "NVHomeMainContainerBusinesses"
      );
      for (const business of processedBusinesses) {
        let listingsHtml = ``;

        if (this.#isBusinessesSearch !== isCalledFromSearch) return

        if (
          !Array.isArray(business.listings) ||
          business.listings.length === 0
        ) {
          listingsHtml +=
            displayListingGenerateHtml._listingVerticalMiniNoListings();
        } else {
          for (const listing of business.listings) {
            listingsHtml +=
              await displayListingGenerateHtml._listingVerticalMini(
                listing,
                business.colors,
                "listingInBusiness",
                business.businessId
              );
          }
        }

        const businessInPackHtml =
          await displayListingGenerateHtml._generateBusiness2v(
            listingsHtml,
            business
          );

        if (this.#isBusinessesSearch !== isCalledFromSearch) return
        businessCon.insertAdjacentHTML("beforeend", businessInPackHtml);
      }

      // const addSet = homeScreen._makeAddSetToInsert();
      // businessCon.insertAdjacentHTML(
      //   "beforeend",
      //   addSet
      // );

      if (this.#isMoreLoadingInitializedForBusinesses) return
      this.#isMoreLoadingInitializedForBusinesses = true;
    } catch (err) {
      if (err.name === "AbortError") {
        // console.log("Display Businesses aborted.");
      } else {
        console.error(err);
      }
    } finally {
      spinner._hideSpinner();
    }
    data.businesses = dataLocal.businesses;
  }
  // END Businesses Handeling




  // START Sellers Handeling
  async _initSellersLoads(reset) {
    console.log("Initializing sellers loads, reset =", reset);

    if (reset) {
      this._emptyContainer('NVHomeMainContainerSellers')

      this.#sellersLastVisDoc = null;
      this.#allSellersLoaded = false;
      this.#isLoadingSellers = false

      this.#currentSearchSellersCount = 0
      this.#currentSearchSellersLimit = 8
      this.#sellersSearchResultpathsArr = []
    }
    setTimeout(() => {
      this._addTheRightPaddingToItemsCon('NVHomeMainContainerSellers', 20);
    }, 10);

    this._searchPlaceHolderChangeTo("Buscar Vendedores");

    this._loadSellers()

  }
  async _loadSellers() {
    if (this.#isLoadingSellers) return;
    this.#isLoadingSellers = true;

    await this._startGetLoopForIndSellers();
    this.#isLoadingSellers = false;
  }
  async _startGetLoopForIndSellers(numberGet = 10) {
    console.warn("called");
    if (!this.#isSellersSearch) {
      console.warn("called here");
      const { listings, lastVisibleDoc } =
        await firebase._getRecentListingsWithFilter(
          this.#sellersLastVisDoc,
          numberGet,
          "accounts",
          "sellerProfileStatus",
          "active",
          true
        );
      console.log(listings, lastVisibleDoc);
      this._fillIndSellers(listings);
      if (listings.length < numberGet) {
        this.#allSellersLoaded = true;
      }
      // lastVisibleDocToUse = lastVisibleDoc;
      this.#sellersLastVisDoc = lastVisibleDoc;
    } else {
      if (this.#currentSearchQuery?.length < 1) return





      console.warn("Searching for:", this.#currentSearchQuery);
      let resultpathsArr = this.#sellersSearchResultpathsArr
      if (this.#sellersSearchResultpathsArr.length < 1) {
        spinner._displaySpinner()
        this.#sellersSearchResultpathsArr = await firebase._NVsearchSellers({ query: this.#currentSearchQuery })
        resultpathsArr = this.#sellersSearchResultpathsArr
        spinner._hideSpinner()
      }
      console.warn(resultpathsArr);

      if (!resultpathsArr || resultpathsArr?.data?.sellers?.length < 1) {
        if (this.#currentSearchListingCount < 1) {
          alert(`No hemos encontrado nada con ${this.#currentSearchQuery}.`)
        }
        return
      } else {
        while (
          this.#currentSearchSellersCount <= this.#currentSearchSellersLimit &&
          this.#currentSearchSellersCount < resultpathsArr?.data?.sellers?.length
        ) {
          const index = this.#currentSearchSellersCount;
          const sellersArr = resultpathsArr.data.sellers;

          // If this is the LAST available listing
          if (index === sellersArr.length - 1) {
            this.#allListingsLoaded = true;
          }

          const resultpathArr = sellersArr[index];
          if (!this.#isSellersSearch) return
          const seller = await firebase._getAnyDocById(`accounts/${resultpathArr}`);
          if (!this.#isSellersSearch) return
          this._fillIndSellers([seller], true);

          this.#currentSearchSellersCount++;
        }

        // ✅ Increase limit AFTER loading this batch
        this.#currentSearchSellersLimit += 6;
      }
    }
  }
  async _fillIndSellers(indSellersIn, isCalledFromSearch = false) {
    if (indSellersIn.length < 1) {
      spinner._hideSpinner();
    }

    try {
      // Generate and display HTML for businesses and their listings
      const sellersCon = document.getElementById(
        "NVHomeMainContainerSellers"
      );
      for (const sellerProfile of indSellersIn) {
        if (this.#isSellersSearch !== isCalledFromSearch) return
        let sellersHtml = await displayIndSellers._display(sellerProfile);

        if (this.#isSellersSearch !== isCalledFromSearch) return
        sellersCon.insertAdjacentHTML("beforeend", sellersHtml);
        // displayIndSellers._insertSellerListings(sellerProfile);
      }


      const addSet = homeScreen._makeAddSetToInsert();
      sellersCon.insertAdjacentHTML(
        "beforeend",
        addSet
      );


      // if (this.#isMoreLoadingInitializedForBusinesses) return;

      // this.#isMoreLoadingInitializedForBusinesses = true;
    } catch (err) {
      if (err.name === "AbortError") {
        // console.log("Display Businesses aborted.");
      } else {
        console.error(err);
      }
    } finally {
      spinner._hideSpinner();
    }
  }
  // END Sellers Handeling



  // START Promoted Items Handeling
  _mixPlatforms(mercadoLibre, amazon, ebay) {

    const sources = [
      { name: 'ml', items: [...mercadoLibre] },
      { name: 'az', items: [...amazon] },
      { name: 'eb', items: [...ebay] }
    ];

    const result = [];

    while (sources.some(s => s.items.length > 0)) {

      // only pick from non-empty sources
      const available = sources.filter(s => s.items.length > 0);

      // randomly choose one source
      const randomSource =
        available[Math.floor(Math.random() * available.length)];

      // take the NEXT item (preserves createdAt order)
      result.push(randomSource.items.shift());
    }

    return result;
  }


  async _initPromotedItmesLoad(reset = false) {

    if (this.#isLoadingPromotedItems) return;
    this.#isLoadingPromotedItems = true;

    setTimeout(() => {
      this._addTheRightPaddingToItemsCon('NVHomeMainContainerPromotedItems', 20);
    }, 10);

    if (reset) {
      this.#lastVisDocMercadoLibre = null;
      this.#lastVisDocAmazon = null;
      this.#lastVisDocEbay = null;

      this.#allPromotedMercadoLibreItemsLoaded = false;
      this.#allPromotedAmazonItemsLoaded = false;
      this.#allPromotedEbayItemsLoaded = false;
    }

    let mercadoLibreItems = [];
    let amazonItems = [];
    let ebayItems = [];

    const getMercadoLibreItems = async () => {
      if (this.#allPromotedMercadoLibreItemsLoaded) return;

      const { items, lastDoc } =
        await firebase._getAllAffiliatedItemsPaginated(
          'afiliated/mercado-libre/afiliatedItems',
          10,
          this.#lastVisDocMercadoLibre
        );

      this.#lastVisDocMercadoLibre = lastDoc;
      mercadoLibreItems = items;

      if (items.length < 1) {
        this.#allPromotedMercadoLibreItemsLoaded = true;
      }
    };

    const getAmazonItems = async () => {
      if (this.#allPromotedAmazonItemsLoaded) return;

      const { items, lastDoc } =
        await firebase._getAllAffiliatedItemsPaginated(
          'afiliated/amazon/afiliatedItems',
          10,
          this.#lastVisDocAmazon
        );

      this.#lastVisDocAmazon = lastDoc;
      amazonItems = items;

      if (items.length < 1) {
        this.#allPromotedAmazonItemsLoaded = true;
      }
    };

    const getEbayItems = async () => {
      if (this.#allPromotedEbayItemsLoaded) return;

      const { items, lastDoc } =
        await firebase._getAllAffiliatedItemsPaginated(
          'afiliated/ebay/afiliatedItems',
          10,
          this.#lastVisDocEbay
        );

      this.#lastVisDocEbay = lastDoc;
      ebayItems = items;

      if (items.length < 1) {
        this.#allPromotedEbayItemsLoaded = true;
      }
    };

    const ske = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const renderCon = document.getElementById('NVHomeMainContainerPromotedItems')

    if (reset) {
      renderCon.innerHTML = ''
      ske.forEach(skeNum => {
        renderCon.insertAdjacentHTML(
          'beforeend',
          displayPromotedItemsGenerateHtml._generateSkeleton(skeNum)
        )
      });

    }

    try {
      await Promise.all([
        getMercadoLibreItems(),
        getAmazonItems(),
        getEbayItems()
      ]);

      const allItems = this._mixPlatforms(
        mercadoLibreItems,
        amazonItems,
        ebayItems
      );

      promotedItems._renderAll(
        'NVHomeMainContainerPromotedItems',
        allItems,
        reset
      );

    } catch (error) {
      console.error('Promoted items load failed:', error);
    } finally {
      this.#isLoadingPromotedItems = false;
    }
  }

  // END Promoted Items Handeling


  _endSearch() {
    const locationFilterParentCon = document.getElementById("locationFilterParentCon");
    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );

    this.#lockHeaderStageDrag = false


    this.#isExitSearch = true;

    SearchStartUpComponentSearchInput.blur()

    this.#currentSearchQuery = ''
    if (this.#inCurrentCategory === "listings") {
      locationFilterParentCon.style.display = 'flex'

      this.#listingsSearchResultpathsArr = []
      this.#currentSearchListingCount = 0
      this.#currentSearchListingLimit = 10

      this.#isListingSearch = false;
      this.#listingsDevided = 'all'
      this._loadListings(true)
    }
    if (this.#inCurrentCategory === "businesses") {
      locationFilterParentCon.style.display = 'none'
      this.#businessesSearchResultpathsArr = []
      this.#currentSearchBusinessesCount = 0
      this.#currentSearchBusinessesLimit = 6

      this.#isBusinessesSearch = false;
      this._initBusinessLoads(true)
    } if (this.#inCurrentCategory === "indsellers") {
      locationFilterParentCon.style.display = 'none'
      this.#currentSearchSellersCount = 0
      this.#currentSearchSellersLimit = 8
      this.#sellersSearchResultpathsArr = []
      this.#isSellersSearch = false;
      this._initSellersLoads(true)
    }
  }
  _startSearch() {
    const locationFilterParentCon = document.getElementById("locationFilterParentCon");
    locationFilterParentCon.style.display = 'none'


    this.#lockHeaderStageDrag = true

    if (this.#isListingSearch || this.#isBusinessesSearch || this.#isSellersSearch) return
    console.warn('called here')
    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );
    if (this.#inCurrentCategory === "listings") {
      this._resetHeaderPosition('NVHomeMainContainerListings', true)
      this.#listingsSearchResultpathsArr = []
      this.#currentSearchListingCount = 0
      this.#currentSearchListingLimit = 10

      this.#isListingSearch = true;
      this.#listingsDevided = 'search'
      this._emptyContainer('NVHomeMainContainerListings')
      this._headerStageReseter('FULL')
    }
    if (this.#inCurrentCategory === "businesses") {
      this._resetHeaderPosition('NVHomeMainContainerBusinesses', true)
      this.#businessesSearchResultpathsArr = []
      this.#currentSearchBusinessesCount = 0
      this.#currentSearchBusinessesLimit = 6

      this.#isBusinessesSearch = true;
      this._initBusinessLoads(true, true)
      this._headerStageReseter('FULL')


    }
    if (this.#inCurrentCategory === "indsellers") {
      this._resetHeaderPosition('NVHomeMainContainerSellers', true)
      this.#currentSearchSellersCount = 0
      this.#currentSearchSellersLimit = 8
      this.#sellersSearchResultpathsArr = []

      this.#isSellersSearch = true;
      this._initSellersLoads(true, true)
      this._headerStageReseter('FULL')


    }
    this.#isExitSearch = false;

    if (this.#startSearchIsActive) return;
    this.#startSearchIsActive = true;

    SearchStartUpComponentSearchInput.addEventListener("blur", (e) => {
      setTimeout(() => {
        if (this.#isExitSearch) return;
        const searchQueryVal = e.target.value.trim();
        console.log(searchQueryVal.length);
        if (searchQueryVal.length < 3 && searchQueryVal.length > 0) {
          alert("Búsqueda no válida. Tiene que ser mayor a 2 carácteres.");
          return;
        }
        if (searchQueryVal.length < 3) {
          return;
        }
        console.log(searchQueryVal);
        this.#currentSearchQuery = searchQueryVal




        if (this.#inCurrentCategory == "listings") {
          this.#listingsSearchResultpathsArr = []
          this.#currentSearchListingCount = 0
          this.#currentSearchListingLimit = 10

          this.#listingsMostRecentLastVisDoc = null
          this.#allListingsLoaded = false
          this._emptyContainer('NVHomeMainContainerListings')
          this._loadListings(true);
        }
        if (this.#inCurrentCategory == "businesses") {
          this.#businessesSearchResultpathsArr = []
          this.#currentSearchBusinessesCount = 0
          this.#currentSearchBusinessesLimit = 6

          this.#businessLastVisDoc = null
          this.#allBusinessesLoaded = false
          this._emptyContainer('NVHomeMainContainerBusinesses')
          this._initBusinessLoads();
        }


        if (this.#inCurrentCategory == "indsellers") {
          this.#currentSearchSellersCount = 0
          this.#currentSearchSellersLimit = 8
          this.#sellersSearchResultpathsArr = []

          this.#businessLastVisDoc = null
          this.#allBusinessesLoaded = false
          this._emptyContainer('NVHomeMainContainerSellers')
          this._initSellersLoads();
        }
      }, 200);
    });
    SearchStartUpComponentSearchInput.addEventListener("keyup", async (e) => {
      if (e.key === "Enter") {
        e.target.blur();
      }
    });


    this._resetHeaderPositionToTop()
  }


  _endLocationFilter() {
    const locationFilterAdjCon = document.getElementById("locationFilterAdjCon");
    const locationFilterOpenerCon = document.getElementById("locationFilterOpenerCon");

    this.#lockHeaderStageDrag = false
    this.#isListingLocationFilter = false;


    this.#isExitSearch = true;
    this.#currentSearchQuery = ''
    if (this.#inCurrentCategory === "listings") {
      locationFilterAdjCon.style.display = 'none'
      locationFilterOpenerCon.style.display = 'flex'

      this.#listingsSearchResultpathsArr = []
      this.#currentSearchListingCount = 0
      this.#currentSearchListingLimit = 10

      this.#listingsDevided = 'all'
      this._loadListings(true)
    }
    if (this.#inCurrentCategory === "businesses") {
      locationFilterAdjCon.style.display = 'none'
      locationFilterOpenerCon.style.display = 'none'
      this.#businessesSearchResultpathsArr = []
      this.#currentSearchBusinessesCount = 0
      this.#currentSearchBusinessesLimit = 6

      this.#isBusinessesSearch = false;
      this._initBusinessLoads(true)
    } if (this.#inCurrentCategory === "indsellers") {
      locationFilterAdjCon.style.display = 'none'
      locationFilterOpenerCon.style.display = 'none'
      this.#currentSearchSellersCount = 0
      this.#currentSearchSellersLimit = 8
      this.#sellersSearchResultpathsArr = []
      this.#isSellersSearch = false;
      this._initSellersLoads(true)
    }
  }
  _startLocationFilter() {
    this.#lockHeaderStageDrag = true
    this._emptyContainer('NVHomeMainContainerListings')
    this._headerStageReseter('FULL')
    this._resetHeaderPosition('NVHomeMainContainerListings', true)
    this.#isListingLocationFilter = true;
    this.#listingsDevided = 'locationFilter'

    const applyFilter = (locationData) => {
      this.#locationFilterData = locationData
      console.log('triggered:', locationData);

      if (!this.#locationFilterData.lat || !this.#locationFilterData.lng) {
        alert("Debes seleccionar una ubicación para filtrar sus alrededores.");
        return;
      }

      this.#locationFilterLastVisibleDoc = null
      this.#allListingsLoadedInLocationFilter = false
      this.#lockHeaderStageDrag = true
      this._emptyContainer('NVHomeMainContainerListings')
      this._loadListings(true)
    }

    this._resetHeaderPositionToTop()
    return { applyFilter }
  }




  // START Used Uop Here NEW



  _handleLinkPreview(containerId, inputId) {
    const container = document.getElementById(containerId);
    const input = document.getElementById(inputId);

    if (!container || !input) return;

    let lastUrl = null;
    let debounceTimer = null;

    input.addEventListener("input", () => {
      const url = input.value.trim();
      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        if (!isValidUrl(url) || url === lastUrl) {
          container.innerHTML = "";
          return;
        }

        lastUrl = url;

        if (!isMercadoLibreSecLink(url)) {
          container.innerHTML = "";
          return;
        }

        showLoading(container);
        fetchMercadoLibrePreview(url, container);
      }, 400);
    });

    /* -------------------- MERCADOLIBRE -------------------- */

    function fetchMercadoLibrePreview(url, container) {
      fetch(`https://api.microlink.io?url=${encodeURIComponent(url)}`)
        .then(res => res.json())
        .then(res => {
          if (!res || res.status !== "success") {
            throw new Error("Microlink failed");
          }
          renderMercadoLibrePreview(container, res.data, url);
        })
        .catch(err => {
          console.error("ML preview error:", err);
          container.innerHTML = `
          <div class="link-preview-error">
            No se pudo cargar la vista previa
          </div>
        `;
        });
    }

    function renderMercadoLibrePreview(container, data, url) {
      const image =
        data.image?.url ||
        data.images?.[0]?.url ||
        null;

      container.innerHTML = `
      <div class="link-preview-card ml-preview">
        ${image ? `<img src="${image}" alt="Producto Mercado Libre">` : ""}

        <div class="link-preview-content">
          <strong>${escapeHtml(data.title || "Producto en Mercado Libre")}</strong>
          <p>${escapeHtml(data.description || "")}</p>

          <a
            href="${url}"
            target="_blank"
            rel="noopener noreferrer"
            class="ml-buy-button"
          >
            Comprar en Mercado Libre
          </a>
        </div>
      </div>
    `;
    }

    /* -------------------- HELPERS -------------------- */

    function isMercadoLibreSecLink(url) {
      try {
        const u = new URL(url);
        return (
          u.hostname.includes("mercadolibre.") &&
          u.pathname.startsWith("/sec/")
        );
      } catch {
        return false;
      }
    }

    function isValidUrl(value) {
      try {
        new URL(value);
        return true;
      } catch {
        return false;
      }
    }

    function showLoading(container) {
      container.innerHTML = `
      <div class="link-preview-loading">
        Cargando vista previa…
      </div>
    `;
    }

    function escapeHtml(text) {
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    }
  }



  async _CTAShareLiting(dataIn, what = 'listing', onlyShare = false) {

    let data = dataIn

    const ctaShareListingLabelText = document.getElementById('ctaShareListingLabelText')
    const CTAShareListing = document.getElementById('CTAShareListing')
    const CTAShareListingImage = document.getElementById('CTAShareListingImage')
    const CTAShareListingLabel = document.getElementById('CTAShareListingLabel')
    const CTAShareListingDescription = document.getElementById('CTAShareListingDescription')
    const CTAShareListingButtonShare = document.getElementById('CTAShareListingButtonShare')
    const CTAShareListingButtonClose = document.getElementById('CTAShareListingButtonClose')
    CTAShareListing.style.display = 'flex'

    let CTALabel = ''
    let label = ''
    let description = ''
    let image = ''

    if (what === 'listing') {

      CTALabel = '¡Listado Publicado con Éxito!'

      console.log('CTAShareLiting')
      let isOnDiscountText = ''
      if (data.onDiscount.amount > 0) {
        isOnDiscountText = 'En descuento ahora'
      }

      image = data.listingImgsIds[0].res_200

      label = `${data.onDiscount.finalPrice} ${data.listingCoin} • ${data.listingName}`
      description = `${data.listingCondition} | ${isOnDiscountText} | ${data.listingDescription}`

    }
    if (what === 'business') {
      CTALabel = '¡Empresa Publicado con Éxito!'


      console.log('CTAShareBusiness')
      image = data.images.profile[0].res_500

      label = `${data.name} • ${data.shortDescription}`
      description = data.about

    }

    CTAShareListingImage.src = image
    ctaShareListingLabelText.textContent = CTALabel
    CTAShareListingLabel.textContent = label
    CTAShareListingDescription.textContent = description
    // }, 500)
    if (this.#CTAShareEventsInitialized) return
    this.#CTAShareEventsInitialized = true

    CTAShareListing.addEventListener('click', (e) => {
      const ignoreClick = e.target.closest(".ctaShareListingCon2")
      if (ignoreClick) return
      CTAShareListing.style.display = 'none'
    })

    CTAShareListingButtonClose.addEventListener('click', (e) => {
      CTAShareListing.style.display = 'none'
    })

    CTAShareListingButtonShare.addEventListener('click', (e) => {

      if (what === 'listing') {
        const btnActionListingShare = document.getElementById('btnActionListingShare')
        btnActionListingShare.click()
        console.log('should share now')
        CTAShareListing.style.display = 'none'
      }
      if (what === 'business') {
        const btnActionBusinessShare = document.getElementById('btnActionBusinessShare')
        if (btnActionBusinessShare) {
          btnActionBusinessShare.click()
          CTAShareListing.style.display = 'none'
          return
        }

        console.log(dataIn);

        if (onlyShare) {
          this._displayTheRightWay(
            dataIn.businessId,
            '',
            'business',
            '',
            null,
            '',
            true,
            null,
            false
          );
        }



        console.log('should share now')
        CTAShareListing.style.display = 'none'
      }
    })




  }



  _getColors() {
    return colors;
  }





  _hideTopToolsCon() {
    return
    const homeHeaderSearchCon1 = document.getElementById(
      "homeHeaderSearchCon1"
    );
    // homeHeaderSearchCon1.style.display = "none";
    homeHeaderSearchCon1.classList.add("homeHeaderSearchCon1disapear");
  }

  _listenAddContainerHeightChanges() {
    const content = document.getElementById('nvHeaderCon2BigAddContainer');
    if (!content) return;

    // Ensure map exists
    if (!this._dynamicHeightStates) {
      this._dynamicHeightStates = new Map();
    }

    // Prevent creating multiple observers
    if (this._addContainerResizeObserver) return;

    let lastHeight = content.offsetHeight;

    this._addContainerResizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {

        const newHeight = this._getTallestChildHeight(content);

        // Ignore if no real change
        if (newHeight === lastHeight) return;

        lastHeight = newHeight;

        // 🔥 Update ALL states
        this._dynamicHeightStates.forEach(state => {
          state.currentHeight = newHeight;
        });

      }
    });

    this._addContainerResizeObserver.observe(content);
  }


  _getTallestChildHeight(container, extra = 20) {
    let tallest = 0;

    for (const child of container.children) {
      const h = child.offsetHeight;
      if (h > tallest) tallest = h;
    }

    return tallest + extra;
  }

  _alignItemsConToHeaderBottom(id) {

    this.#lockHeaderStage = true;

    const MAX_ATTEMPTS = 50;
    const RETRY_DELAY = 200;
    const SCROLL_SETTLE_TIME = 400;

    let attempts = 0;

    const tryScroll = () => {

      const content = document.getElementById('nvHeaderCon2BigAddContainer');
      const scrollEl = document.getElementById(id);

      if (!content || !scrollEl) return;

      const gottenDelta = this._getTallestChildHeight(content);

      if (!gottenDelta || gottenDelta <= 0) {
        return retry();
      }

      const target = gottenDelta - 20;

      // ⭐ already aligned
      if (scrollEl.scrollTop >= target - 2) {
        this.#lockHeaderStage = false;
        console.log('UNLOCKED (already aligned)');
        return;
      }

      const calcDelta = target - scrollEl.scrollTop;

      scrollEl.scrollBy({
        top: calcDelta,
        behavior: 'smooth'
      });

      const startScrollTop = scrollEl.scrollTop;

      setTimeout(() => {

        const current = scrollEl.scrollTop;

        // ⭐ SUCCESS
        if (current >= target - 2) {
          this.#lockHeaderStage = false;
          console.log('UNLOCKED (scroll finished)');
          return;
        }

        // ⭐ NO PROGRESS → retry
        if (Math.abs(current - startScrollTop) < 1) {
          retry();
          return;
        }

        // ⭐ partial progress → try again
        retry();

      }, SCROLL_SETTLE_TIME);
    };

    const retry = () => {
      attempts++;

      if (attempts < MAX_ATTEMPTS) {
        setTimeout(tryScroll, RETRY_DELAY);
      } else {
        this.#lockHeaderStage = false;
        console.log('UNLOCKED (max attempts reached)');
      }
    };

    setTimeout(tryScroll, 30);
  }




  _headerStageReseter(stage) {

    const scrollEl = document.getElementById(this.#currentScrollId);
    const header = document.getElementById('homeHeaderSearchCon1');
    const ads = document.getElementById('nvHeaderCon2BigAddContainer');

    if (!scrollEl || !header || !ads) return;

    const heights = {
      adsHeight: ads.offsetHeight,
      headerHeight: header.offsetHeight
    };

    let translate = 0;
    let scrollTarget = 0;

    switch (stage) {

      case 'FULL':
        translate = 0;
        scrollTarget = 0;
        break;

      case 'HALF':
        translate = -heights.adsHeight;
        scrollTarget = heights.adsHeight;
        break;

      case 'HIDDEN':
        translate = -heights.headerHeight;
        scrollTarget = heights.headerHeight;
        break;

      default:
        console.warn('_headerStageReseter: invalid stage', stage);
        return;
    }

    // ⭐ Guard scroll logic
    this.#isProgrammaticScroll = true;
    this.#lastStage = stage;

    // ⭐ Animate header
    header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
    header.style.transform = `translateY(${translate}px)`;

    // ⭐ Sync scroll
    scrollEl.scrollTo({
      top: scrollTarget,
      behavior: 'smooth'
    });

    // ⭐ Release guard after animation
    clearTimeout(this.#stageResetTimer);
    this.#stageResetTimer = setTimeout(() => {
      this.#isProgrammaticScroll = false;
    }, 350);

  }


  _addPullDownBar(add = false) {
    // Maybe add this pull down bar later 
    return

    const header = document.getElementById('homeHeaderSearchCon1');
    const pullDown = document.getElementById('NVHeaderConSearchConPullDownCon1');
    pullDown.classList.remove('NVHeaderConSearchConPullDownCon1Act')
    header.classList.remove('homeHeaderSearchCon1BorderRadius')
    if (add) {
      this.#lockHeaderStage = true
      pullDown.classList.add('NVHeaderConSearchConPullDownCon1Act')
      header.classList.add('homeHeaderSearchCon1BorderRadius')
      setTimeout(() => {
        this.#lockHeaderStage = false
      }, 1000);
    }
  }


  _addHeader3Stage(scrollId) {

    this.#currentScrollId = scrollId;

    const scrollEl = document.getElementById(scrollId);
    const header = document.getElementById('homeHeaderSearchCon1');
    const ads = document.getElementById('nvHeaderCon2BigAddContainer');

    console.warn(ads);

    if (!scrollEl || !header || !ads) return;

    const BUFFER_DOWN = -5;
    const BUFFER_UP = 5;
    const UP_SCROLL_SPEED_THRESHOLD = 2.5;

    let lastStage = 'FULL';
    let lastScrollTop = scrollEl.scrollTop;
    let lowestScrollReached = scrollEl.scrollTop;

    let lastScrollTime = performance.now();

    let isDragging = false;
    let isDragScroll = false;

    let dragStartY = 0;
    let dragStartX = 0;
    let horizontalDragLock = false;

    let startTranslate = 0;
    let currentTranslate = 0;
    let dragDirection = 0;

    const getHeights = () => ({
      adsHeight: ads.offsetHeight,
      headerHeight: header.offsetHeight,
      halfDistance: header.offsetHeight - ads.offsetHeight
    });

    const clamp = (val, min, max) => Math.max(min, Math.min(max, val));

    const getCurrentTranslate = () => {
      const style = window.getComputedStyle(header);
      const transform = style.transform;
      if (transform === 'none') return 0;
      const matrix = new DOMMatrixReadOnly(transform);
      return matrix.m42;
    };

    const applyTranslate = (y) => {
      header.style.transform = `translateY(${y}px)`;
    };

    const syncScrollToStage = (stage, heights, isInScroll = true) => {

      if (isInScroll) return

      const isNearTop = scrollEl.scrollTop <= heights.headerHeight + 40;
      if (!isNearTop) return;

      let target = 0;

      if (stage === 'FULL') target = 0;
      if (stage === 'HALF') target = heights.adsHeight;
      if (stage === 'HIDDEN') target = heights.headerHeight;

      isDragScroll = true;

      scrollEl.scrollTo({ top: target, behavior: 'smooth' });

      clearTimeout(scrollEl._scrollGuardTimer);
      scrollEl._scrollGuardTimer = setTimeout(() => {
        isDragScroll = false;
      }, 350);

    };

    const setStage = (stage, heights, isFromScroll) => {

      if (this.#lockHeaderStage) return;
      if (stage === lastStage) return;

      lastStage = stage;

      header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';

      switch (stage) {

        case 'FULL':
          applyTranslate(0);
          this._addPullDownBar(false);
          break;

        case 'HALF':
          applyTranslate(-heights.adsHeight);
          this._addPullDownBar(false);
          break;

        case 'HIDDEN':
          applyTranslate(-heights.headerHeight);
          this._addPullDownBar(true);
          break;

      }

      syncScrollToStage(stage, heights, isFromScroll);

    };

    const snapByDirection = (isFromScroll) => {

      const heights = getHeights();

      if (dragDirection < 0) {

        if (lastStage === 'FULL') return setStage('HALF', heights, isFromScroll);
        if (lastStage === 'HALF') return setStage('HIDDEN', heights, isFromScroll);
        return setStage('HIDDEN', heights, isFromScroll);

      }

      if (dragDirection > 0) {

        if (lastStage === 'HIDDEN') return setStage('HALF', heights, isFromScroll);
        if (lastStage === 'HALF') return setStage('FULL', heights, isFromScroll);
        return setStage('FULL', heights, isFromScroll);

      }

      setStage(lastStage, heights, isFromScroll);

    };

    scrollEl.addEventListener('scroll', () => {

      if (isDragScroll) return;
      if (this.#lockHeaderStageDrag) return;
      if (this.#lockHeaderStage) return;
      if (isDragging) return;

      const now = performance.now();
      const timeDelta = now - lastScrollTime;
      lastScrollTime = now;

      const scrollTop = scrollEl.scrollTop;
      const heights = getHeights();

      const delta = scrollTop - lastScrollTop;
      const speed = Math.abs(delta) / (timeDelta || 1);

      const distanceToTop = scrollTop;

      if (scrollTop <= BUFFER_UP) {

        header.style.transition = 'transform 260ms cubic-bezier(.22,.61,.36,1)';
        setStage('FULL', heights);

        lowestScrollReached = 0;
        lastScrollTop = scrollTop;
        return;

      }

      if (scrollTop > lowestScrollReached) {
        lowestScrollReached = scrollTop;
      }

      if (delta > 0) {

        if (scrollTop <= heights.adsHeight + BUFFER_DOWN) {
          setStage('FULL', heights);
        }
        else if (scrollTop <= heights.headerHeight + BUFFER_DOWN) {
          setStage('HALF', heights);
        }
        else {
          setStage('HIDDEN', heights);
        }

      }

      if (delta < 0) {

        const shouldUseSpeedGuard = distanceToTop > heights.headerHeight;

        if (shouldUseSpeedGuard && speed < UP_SCROLL_SPEED_THRESHOLD) {
          lastScrollTop = scrollTop;
          return;
        }

        const distanceUp = lowestScrollReached - scrollTop;

        if (distanceUp >= heights.halfDistance + BUFFER_UP) {
          setStage('HALF', heights);
        }

        if (
          scrollTop <= heights.adsHeight + BUFFER_UP &&
          distanceUp >= heights.adsHeight + BUFFER_UP
        ) {
          setStage('FULL', heights);
        }

        if (scrollTop <= heights.adsHeight + BUFFER_UP) {
          lowestScrollReached = scrollTop;
        }

      }

      lastScrollTop = scrollTop;

    }, { passive: true });


    /* ---------------- DRAG SYSTEM ---------------- */

    header.addEventListener('pointerdown', (e) => {

      if (this.#lockHeaderStageDrag) return;
      if (this.#lockHeaderStage) return;
      if (e.pointerType !== 'touch') return;

      isDragging = true;
      dragDirection = 0;

      dragStartY = e.clientY;
      dragStartX = e.clientX;
      horizontalDragLock = false;

      startTranslate = getCurrentTranslate();

      header.style.transition = 'none';
      header.setPointerCapture(e.pointerId);

    });

    header.addEventListener('pointermove', (e) => {

      if (this.#lockHeaderStageDrag) return;
      if (!isDragging) return;

      const heights = getHeights();

      const deltaY = e.clientY - dragStartY;
      const deltaX = e.clientX - dragStartX;

      if (!horizontalDragLock) {

        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          horizontalDragLock = true;
          return;
        }

      }

      if (horizontalDragLock) return;

      const delta = deltaY;

      dragDirection = delta > 0 ? 1 : -1;

      currentTranslate = startTranslate + delta;

      currentTranslate = clamp(
        currentTranslate,
        -heights.headerHeight,
        0
      );

      applyTranslate(currentTranslate);

    });

    const endDrag = (e) => {

      if (!isDragging) return;

      isDragging = false;

      header.releasePointerCapture(e.pointerId);

      snapByDirection(false);
    };

    header.addEventListener('pointerup', endDrag);
    header.addEventListener('pointercancel', endDrag);

  }


  _setActiveDynamicHeightContainer(scrollId) {
    console.log('here');
    const scrollEl = document.getElementById(scrollId);
    const wrapper = document.getElementById('nvHeaderCon2BigAddContainerA');

    if (!scrollEl || !this._dynamicHeightStates) return;

    const state = this._dynamicHeightStates.get(scrollEl);
    if (!state) return;

    this._activeScrollContainer = scrollEl;

    wrapper.style.maxHeight =
      state.currentHeight > 0 ? state.currentHeight + 'px' : '0px';

    state.lastScrollTop = scrollEl.scrollTop;
  }

  _getNaturalHeight(el) {

    const prevDisplay = el.style.display;
    const prevMaxHeight = el.style.maxHeight;

    el.style.display = 'flex';
    el.style.maxHeight = 'none';

    const height = el.scrollHeight;

    el.style.display = prevDisplay;
    el.style.maxHeight = prevMaxHeight;

    return height;
  }



  _resetHeaderPosition(id, reset = false) {
    const header = document.getElementById("homeHeaderSearchCon1");
    const scrollCon = document.getElementById(id);

    if (!header || !scrollCon) return;

    const state = this.#scrollStates.get(id);
    if (!state) return;

    // 🔥 If reset requested → wipe state
    if (reset) {
      state.lastScrollTop = 0;
      state.currentTranslate = 0;
      state.ticking = false;

      header.style.transform = "translateY(0px)";
      scrollCon.scrollTop = 0;

      return;
    }

    // 🔄 Otherwise restore saved position
    header.style.transform =
      `translateY(${state.currentTranslate}px)`;

    scrollCon.scrollTop = state.lastScrollTop;
  }


  _resetHeaderPositionToTop() {
    const header = document.getElementById("homeHeaderSearchCon1");
    if (!header) return;
    header.style.transform = "translateY(0px)";
  }



  _showTopToolsCon() {
    const homeHeaderSearchCon1 = document.getElementById(
      "homeHeaderSearchCon1"
    );
    // homeHeaderSearchCon1.style.display = "flex";
    homeHeaderSearchCon1.classList.remove("homeHeaderSearchCon1disapear");
  }

  _detectScrollDirection(container, callback) {
    let lastScrollTop = container.scrollTop;

    container.addEventListener("scroll", () => {
      const currentScrollTop = container.scrollTop;
      const diff = currentScrollTop - lastScrollTop;

      if (currentScrollTop < 0) return;

      if (Math.abs(diff) > 50) {
        const direction = diff > 0 ? "down" : "up";
        this._scrollDirectionDecide(direction);
        lastScrollTop = currentScrollTop; // reset after trigger
      }
    });
  }
  _scrollDirectionDecide(direction) {
    if (direction === "up") {
      this._showTopToolsCon();
      if (!this.#userIsInSearch) {
        nav._show();
      }
    }
    if (direction === "down") {
      this._hideTopToolsCon();
      if (!this.#userIsInSearch) {
        nav._hide();
      }
    }
  }

  _abortDisplays() {
    this.abortController.abort(); // Abort all ongoing tasks
    console.log("All display tasks have been aborted.");
    // Reset for future calls
    this.abortController = new AbortController();
  }

  async _getBusinessDataById(id) {
    return data.businesses.find((business) => business.businessId === id);
  }
  // Start Initial Displays

  async _displayTheRightWay(
    parrentId,
    listingId = null,
    lives,
    from,
    share,
    imgRatio,
    CTAShare,
    listIn,
    onlyShare = false
  ) {
    let listingDataBase = null;
    let businessData = null;

    console.log(
      'parrentId:', parrentId,
      'listingId:', listingId,
      'lives:', lives,
      'from:', from,
      'share:', share,
      'imgRatio:', imgRatio,
      'CTAShare:', CTAShare,
      'onlyShare:', onlyShare,
    );

    try {
      spinner._displaySpinner('Cargando...')

      if (lives === 'business') {

        let listingData = null
        let list = listIn

        if (from !== 'business') {
          spinner._displaySpinner('Cargando negocio...')
          businessData = await firebase._getBusinessById(parrentId);
          console.log(businessData);

        }

        if (CTAShare && onlyShare) {
          this._CTAShareLiting(businessData, 'business', onlyShare)
          return
        }


        if (listingId) {
          spinner._displaySpinner('Cargando listado...')

          listingData = await firebase._getAnyDocById(
            `businesses/${parrentId}/listings/${listingId}`
          );
          listingDataBase = listingData

        }


        DisplayBusinessEach._init(businessData, share, list);

        if (listingData) {
          list = listingData?.listingMachineType
          displayListingEach._init(listingData, null, null, share, null, imgRatio);
        }
      }


      if (lives === 'seller') {
        spinner._displaySpinner('Cargando listado...')
        let listingData = null
        listingData = await firebase._getAnyDocById(
          `accounts/${parrentId}/listings/${listingId}`
        );

        if (!listingData) {
          listingData = await firebase._getAnyDocById(
            `listings/${listingId}`
          );
        }
        listingDataBase = listingData
        displayListingEach._init(listingData, null, null, share, null, imgRatio);
      }

    } catch (error) {
      alert(error.message)
    } finally {
      spinner._hideSpinner()
      if (CTAShare) {
        if (lives === 'business' && !listingId) {
          this._CTAShareLiting(businessData, 'business')
        } else {
          this._CTAShareLiting(listingDataBase, 'listing')
        }
      }
    }
  }


  _displaySellerEach(sellerId) {
    console.log('seller clicked:', sellerId);
    // indSellersIn._displaySellerEach(sellerId)

    displayIndSellers._displaySellerEach(sellerId)

  }

  _setActiveCategory(category, listingsDevided) {
    this.#listingsDevided = listingsDevided;
    const target = document.querySelector(
      `.headerCatSelectorOnClick[data-category="${category}"]`
    );

    setTimeout(() => {
      if (listingsDevided === 'search') {
        const input = document.getElementById('SearchStartUpComponentSearchInput')
        input.focus();
      }
      if (listingsDevided === 'locationFilter') {
        homeScreen._openLocationFilter()
      }
    }, 200)

    if (!target) {
      console.warn("Category not found:", category);
      return;
    }

    target.click(); // 🔥 reuse your existing logic
  }

  async _actionsOnListingInEditElement(action = null, sellerId = null, businessId = null, listingIdIn = null) {
    console.log('El dots', this.#listingInEditDotsButton);

    console.warn('HERE');

    let listingId = listingIdIn || this.#listingInEditId;
    console.warn('HERE');

    console.log(action, sellerId, businessId, listingId);
    if (!action) return;
    console.warn('HERE');

    if (action === 'remove') {
      console.warn('HERE');
      if (this.#listingInEditType === 'vertical' || this.#listingInEditType === 'business') {
        console.warn('HERE');
        this.#listingInEditElement.remove();
      } else if (this.#listingInEditType === 'each') {
        console.warn('HERE');
        StackDisplay._goBackOnStack(null, this.#listingInEditDotsButton)
      }
    }



    if (action === 'edit') {
      console.warn('HERE');
      let listingData

      if (businessId) {
        console.warn('HERE');
        listingData = await firebase._getAnyDocById(`businesses/${businessId}/listings/${listingId}`)
      } else {
        console.warn('HERE');
        listingData = await firebase._getAnyDocById(`accounts/${sellerId}/listings/${listingId}`)
      }

      console.log('listingData', listingData);

      if (this.#listingInEditType === 'vertical' || this.#listingInEditType === 'business') {
        console.warn('HERE');
        // Handle vertical listing edit

        function htmlToElement(html) {
          const temp = document.createElement("div");
          temp.innerHTML = html.trim();
          return temp.firstElementChild;
        }

        let business = false
        if (this.#listingInEditType === 'business') {
          business = true
        }

        const newEl = htmlToElement(
          displayListingGenerateHtml._listingVerticalNV(listingData, null, null, business)
        );

        console.log(newEl, this.#listingInEditElement);

        if (!newEl || !this.#listingInEditElement) return;
        this.#listingInEditElement.replaceWith(newEl);
      } else if (this.#listingInEditType === 'each') {
        console.warn('HERE');
        StackDisplay._goBackOnStack(null, this.#listingInEditDotsButton)

      }
    }
  }

  _events() {
    window.addEventListener("click", async (e) => {
      const targetElementListing = e.target.closest(".ActionOpenForDisplayListing"); // Find the closest ancestor with the class
      const targetElementBusiness = e.target.closest(".ActionOpenForDisplay"); // Find the closest ancestor with the class
      const targetElementSeller = e.target.closest(".ActionOpenForDisplaySeller"); // Find the closest ancestor with the class

      if (targetElementListing) { // Ensure an element was clicked
        const isReturn = e.target.closest(".returnForActionOpenForDisplay");
        if (isReturn) return;

        const businessId = targetElementListing.getAttribute("data-businessid") || "";
        const sellerId = targetElementListing.getAttribute("data-sellerid") || "";
        const listingId = targetElementListing.getAttribute("data-listingid") || "";
        const lives = targetElementListing.getAttribute("data-lives") || "";
        const from = targetElementListing.getAttribute("data-from") || "";

        const imgIn = targetElementListing.querySelector('.nvListingVerCon2').querySelector('.nvListingVerCon2Img')


        // get ration here
        function getClosestAspectRatioClassFromElement(el) {
          console.log(el);
          const ratioMap = {
            "aspectRatio_16-9": 16 / 9,
            "aspectRatio_9-6": 9 / 6,
            "aspectRatio_4-3": 4 / 3,
            "aspectRatio_1-1": 1,
            "aspectRatio_3-4": 3 / 4,
            // "aspectRatio_6-9": 6 / 9,
          };

          const width = el.naturalWidth || el.clientWidth || el.offsetWidth;
          const height = el.naturalHeight || el.clientHeight || el.offsetHeight;

          if (!width || !height) return "aspectRatio_16-9"; // fallback

          const actual = width / height;
          let closestClass = "aspectRatio_16-9";
          let smallestDiff = Infinity;

          for (const [cls, ratio] of Object.entries(ratioMap)) {
            const diff = Math.abs(actual - ratio);
            if (diff < smallestDiff) {
              smallestDiff = diff;
              closestClass = cls;
            }
          }

          return closestClass;
        }

        let parrentId = sellerId
        if (businessId && businessId !== 'undefined') {
          parrentId = businessId
        }
        const imgRatio = getClosestAspectRatioClassFromElement(imgIn)
        console.warn(imgRatio);

        // Ensure correct data is passed
        this._displayTheRightWay(
          parrentId,
          listingId,
          lives,
          from,
          null,
          imgRatio
        );
      }
      if (targetElementBusiness) { // Ensure an element was clicked

        try {


          let businessIdLocal = ''
          const businessParent = e.target.closest(".v20BusinessCon1A");
          const businessParentMain = e.target.closest(".nvBusinessVerCon1A");
          if (businessParent) {
            businessIdLocal = businessParent.dataset.businessid
          }

          const isReturn = e.target.closest(".returnForActionOpenForDisplay");
          const isDelete = e.target.closest(".v20BusinessCon14Delete");
          const isEdit = e.target.closest(".v20BusinessCon14Edit");



          if (isDelete && businessIdLocal) {
            const confirmDelete = confirm('Estás seguro que quieres eliminar este negocio? Esto elimina también todos los listados publicado en este negocio. Esta acción no se puede deshacer.')
            if (!confirmDelete) return

            spinner._displaySpinner('Por favor espera mientras estamos eliminando tu empresa.')

            const { data } = await firebase._NVDeleteBusiness({ businessId: businessIdLocal })
            console.log(data);

            if (data.status === 'success') {

              const userData = firebase._getLatestCurrentUserData()
              firebase._getUserDataFromBase(userData.userId)

              alert('Tu empresa ha side eliminado con éxito.')

              if (businessParentMain) {
                businessParentMain.remove()
              }

              // StackDisplay._goBackOnStack(businessOpenOptionsEvent, btnActionBusinessDelete)
            }
            return
          }
          if (isEdit && businessIdLocal) {
            businessEach._EditBusinessCall(businessIdLocal)
            return
          }



          if (isReturn) return;

          const businessId = targetElementBusiness.getAttribute("data-businessid") || "";
          const lives = targetElementBusiness.getAttribute("data-lives") || "";


          console.log("Extracted Data:", {
            businessId,
            lives,
          });






          let listingId = ''
          let from = ''
          let imgRatio = ''

          // Ensure correct data is passed
          this._displayTheRightWay(
            businessId,
            listingId,
            lives,
            from,
            null,
            imgRatio
          );
        } catch (error) {
          console.log(error);
        } finally {
          spinner._hideSpinner()
        }
      }


      if (targetElementSeller) {
        const isEmail = e.target.closest(".nvSellerProfileText2");
        const isBusiness = e.target.closest(".v20BusinessCon1A");
        const isListing = e.target.closest(".nvListingVerCon1");
        if (isEmail || isBusiness || isListing) return;

        const sellerId = targetElementSeller.getAttribute("data-sellerid") || null;
        if (!sellerId) return;
        this._displaySellerEach(sellerId)
      }
    });
    window.addEventListener("click", (e) => {
      const targetElementListing = e.target.closest(".ActionOpenForDisplayListing");
      const targetElementListingEach = e.target.closest(".nvListingEachCon1A");
      // ActionOpenForDisplay;

      const openListingEditOptions = e.target.closest(
        ".openListingEditOptionsGlobal"
      );
      const openListingShareGlobal = e.target.closest(
        ".openListingShareGlobal"
      );
      const openListingBoostGlobal = e.target.closest(
        ".openListingBoostGlobal"
      );
      const PopOverActionsMenuCon1Closest = e.target.closest(
        ".PopOverActionsMenuCon1"
      );
      const listingParent = e.target.closest(".nvListingVerCon1");

      if (!PopOverActionsMenuCon1Closest) {
        // ownListings._closePopOver();
      }

      if (openListingShareGlobal) {
        const actionCon = e.target.closest(".ActionOpenForDisplay");
        if (!actionCon) return;
        const listingId = actionCon.dataset.id;
        const businessId = actionCon.dataset.businessid;
        ownListings._openPopOver("share", businessId, listingId, e);
        console.log("should open share");
        return;
      }
      if (openListingBoostGlobal) {
        const actionCon = e.target.closest(".ActionOpenForDisplay");
        if (!actionCon) return;
        const listingId = actionCon.dataset.id;
        const businessId = actionCon.dataset.businessid;
        ownListings._openPopOver("boost", businessId, listingId, e);
        console.log("should open boost");
        return;
      }
      if (openListingEditOptions) {

        let element = ''
        let deleteOnly = false

        if (listingParent) {
          const dO = listingParent.dataset.deleteonly
          if (dO === 'true') {
            deleteOnly = true
          }
        }

        this.#listingInEditType = 'vertical'
        if (targetElementListingEach) {
          element = targetElementListingEach
          this.#listingInEditType = 'each'
        } else {
          const hasPaddingParent = targetElementListing.closest(".nvListingVerCon1A");
          const hasPaddingParentBusiness = targetElementListing.closest(".nvBusinessVerCon1A");
          if (hasPaddingParentBusiness) {
            this.#listingInEditType = 'business'
          }
          if (hasPaddingParent) {
            element = hasPaddingParent
          } else {
            element = targetElementListing
          }
        }





        console.log('here');

        const businessId = targetElementListing?.getAttribute("data-businessid") || targetElementListingEach?.getAttribute("data-businessid") || "";
        const listingId = targetElementListing?.getAttribute("data-listingid") || targetElementListingEach?.getAttribute("data-listingid") || "";

        ownListings._openPopOver("options", businessId, listingId, e, deleteOnly);


        this.#listingInEditElement = element;
        this.#listingInEditDotsButton = openListingEditOptions;
        this.#listingInEditId = listingId;
        return;
      }

      const isImg = e.target.closest(".ImgForBigDisplay");
      const isImgParent = e.target.closest(".ImgForBigDisplayParentCon");
      const hasOriginalImages = e.target.closest(".hasOriginalImages");

      if (hasOriginalImages && isImg) {
        console.log('here');
        const imgs = hasOriginalImages.dataset.origimg.split('°-°|°-°?°-°|°-°')
        console.log(imgs);
        displayListingEach._myOwnImgDisplayerNotAIs(imgs, displayListingEach._getCurrentImageIndex());

      } else if (hasOriginalImages && isImgParent) {
        console.log('here');
        const imgs = hasOriginalImages.dataset.origimg.split('°-°|°-°?°-°|°-°')
        console.log(imgs);
        displayListingEach._myOwnImgDisplayerNotAIs(imgs, displayListingEach._getCurrentImageIndex());

      } else {
        console.log('here');
        if (isImg) {
          console.log('here');
          displayListingEach._myOwnImgDisplayerNotAIs([isImg.src]);
        }

        if (isImgParent) {
          console.log('here');
          const img = isImgParent.querySelector('img')

          displayListingEach._myOwnImgDisplayerNotAIs([img.src]);
        }
      }

    });
    window.addEventListener("click", (e) => {
      const openHelp = e.target.closest(".openHelp");
      if (openHelp) {
        const helpWith = openHelp.dataset.helpwith;
        if (helpWith) {
          help._open(helpWith);
        }
      }
    });



    const categoryContainers = document.querySelectorAll(
      ".headerCatSelectorOnClick"
    );

    categoryContainers.forEach((container) => {
      container.addEventListener("click", (e) => {
        const activeContainer = e.target.closest(
          ".headerCatSelectorOnClick"
        );


        if (!activeContainer) return;
        const { category } = activeContainer.dataset;

        // 🔄 Reset all
        categoryContainers.forEach((item) => {

          // if (category !== 'promotedItems') {
          item.classList.remove("homeHeaderCategorySelectCon1Act");

          const con2 = item.querySelector(".homeHeaderCategorySelectCon2");
          const text = item.querySelector(".homeHeaderSearchText1");
          const text2 = item.querySelector(".homeHeaderSearchText1B");

          con2?.classList.remove("homeHeaderCategorySelectCon2Act");
          text?.classList.remove("homeHeaderSearchText1ACT");
          text2?.classList.remove("homeHeaderSearchText1BACT");
          item?.classList.remove("homeHeaderCategorySelectCon1ACT");

          item.classList.remove("homeHeaderCategorySelectorPromotedItemsCon1ACT");
          const con2Pro = item.querySelector(".homeHeaderCategorySelectorPromotedItemsCon4");
          con2Pro?.classList.remove("homeHeaderCategorySelectorPromotedItemsCon4ACT");


        });

        // 🎯 Activate clicked
        if (category !== 'promotedItems') {
          const selector1 = activeContainer.querySelector(".homeHeaderCategorySelectCon2");
          const text = activeContainer.querySelector(".homeHeaderSearchText1");
          const text2 = activeContainer.querySelector(".homeHeaderSearchText1B");
          if (!selector1) return;


          activeContainer.classList.add("homeHeaderCategorySelectCon1Act");
          selector1.classList.add("homeHeaderCategorySelectCon2Act");
          text?.classList.add("homeHeaderSearchText1ACT");
          text2?.classList.add("homeHeaderSearchText1BACT");
          activeContainer?.classList.add("homeHeaderCategorySelectCon1ACT");

        } else {
          activeContainer.classList.add("homeHeaderCategorySelectorPromotedItemsCon1ACT");
          const con2 = activeContainer.querySelector(".homeHeaderCategorySelectorPromotedItemsCon4");
          con2?.classList.add("homeHeaderCategorySelectorPromotedItemsCon4ACT");

        }




        this._changeMainCategory(category);

        // 🎯 Center the active container
        const scrollParent = activeContainer.parentElement;

        if (scrollParent) {
          const parentRect = scrollParent.getBoundingClientRect();
          const childRect = activeContainer.getBoundingClientRect();

          const offset =
            childRect.left -
            parentRect.left -
            parentRect.width / 2 +
            childRect.width / 2;

          scrollParent.scrollBy({
            left: offset,
            behavior: "smooth",
          });
        }
      });
    });

  }



  async _getSetStats() {
    // return
    const appvisits = await firebase._getStats("stats/siteVisits/count");
    const numListingsCreated = await firebase._getStats(
      "stats/listingsCreated/count"
    );
    const numListingsDeleted = await firebase._getStats(
      "stats/listingsDeleted/count"
    );

    const numListings = numListingsCreated - numListingsDeleted;

    const numBusinessesCreated = await firebase._getStats(
      "stats/businessesCreated/count"
    );
    const numBusinessesDeleted = await firebase._getStats(
      "stats/businessDeleted/count"
    );
    // const numBusinessesDeleted = await firebase._getStats(
    //   "stats/BusinessesDeleted/count"
    // );
    const numBusinesses = numBusinessesCreated - numBusinessesDeleted;

    const numSellerProfilesCreated = await firebase._getStats(
      "stats/sellerProfilesCreated/count"
    );
    // const numSellerProfilesDeleted = await firebase._getStats(
    //   "stats/SellerProfilesDeleted/count"
    // );
    const numSellerProfiles = numSellerProfilesCreated;
    // - numSellerProfilesDeleted;

    const homeHeaderSearchText1BListings = document.getElementById(
      "homeHeaderSearchText1BListings"
    );
    const homeHeaderSearchText1BBusinesses = document.getElementById(
      "homeHeaderSearchText1BBusinesses"
    );
    const homeHeaderSearchText1BSellers = document.getElementById(
      "homeHeaderSearchText1BSellers"
    );
    // const appVisitsStats = document.getElementById("appVisitsStats");
    // const appVisitsStatsMainCon = document.getElementById(
    //   "appVisitsStatsMainCon"
    // );

    // appVisitsStatsMainCon.addEventListener("click", () => {
    //   // alert(
    //   //   `¡Esta página ya cuenta con ${GENRALHELPERS._formatToPrice(
    //   //     appvisits
    //   //   )} visitas!`
    //   // );
    //   ctaAlert._openCTARegister(
    //     true,
    //     "Estadísticas de Mercado MAI",
    //     "¡Ya logramos!"
    //   );
    // });

    // GENRALHELPERS._startLoopAnimation("appVisitsStatsMainCon");

    homeHeaderSearchText1BListings.textContent = numListings;
    homeHeaderSearchText1BBusinesses.textContent = numBusinesses;
    homeHeaderSearchText1BSellers.textContent = numSellerProfiles;
    // appVisitsStats.textContent = GENRALHELPERS._formatNumberShort(appvisits);
  }

  async _init() {
    this.#isMoreLoadingInitializedForBusinesses = false;








    this.#startSearchIsActive = false;
    // console.warn("yep called it here");
    this._events();
    // this._getSetStats();
    this._addHeader3Stage('NVHomeMainContainerListings')
    this._activateDetectScrollToBottomListings(100);


    // const conatinerForBackgroundImage = document.getElementById(
    //   "MainHomeContainerForAllItemsDisplay"
    // );

    // conatinerForBackgroundImage.style.backgroundSize = "cover";
    // conatinerForBackgroundImage.style.backgroundPosition = "center";
    // conatinerForBackgroundImage.style.backgroundRepeat = "no-repeat";
  }











  _searchPlaceHolderChangeTo(changeTo) {
    const SearchStartUpComponentSearchInput = document.getElementById(
      "SearchStartUpComponentSearchInput"
    );
    console.log(changeTo);
    SearchStartUpComponentSearchInput.placeholder = changeTo;
  }



  // _handleFromMostRecentSwitch(status) {

  //   this._headerStageReseter('HALF')
  //   this._alignItemsConToHeaderBottom('NVHomeMainContainerListings')
  //   const MainHomeContainerForAllItemsDisplay = document.getElementById(
  //     "NVHomeMainContainerListings"
  //   );
  //   MainHomeContainerForAllItemsDisplay.innerHTML = "";
  //   if (status === false) {
  //   }
  //   if (status) {
  //     this.#displayFromMostRecentListings = true;
  //     this.#trackedRequestNumber++;
  //   } else {
  //     this.#displayFromMostRecentListings = false;
  //   }
  // this._startInitialLoading();





  _getLocalBusinessData(businessId) {
    return data.businesses[businessId];
  }
}
export default new AllDisplaysInitial();
